import React from 'react';
import LeadsBoard from '../../components/dashboard/LeadsBoard';
import GrowthBoard from '../../components/dashboard/GrowthBoard';
import AccountsTable from '../../components/dashboard/AccountsBoard';

const DashboardWidgets = () => (
  <>
    <LeadsBoard />
    <GrowthBoard />
    <AccountsTable />
  </>
);

export default DashboardWidgets;
